import React from 'react'
import styles from './index.module.less'


const ResourcePreviewContent = ({type, text, picUrl, targetUrl, imageRatio}) => {
  return (
    <div style={{width: 350}}>
      <div style={{ height: 350 / (imageRatio || 1), background: '#fefefe' }}>
        <img
          alt={picUrl}
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          src={picUrl}
        />
      </div>
      <div className={styles.linkWrap} title={text}>{text}</div>
    </div>
  )
}

export default ResourcePreviewContent


// WEBPACK FOOTER //
// ./src/compenents/ResourcePreviewContent/index.js